import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";

const COLORS = ["#2e6c2e", "#348234", "#5BAE5B", "#A8D8A8", "#0e1410", "#ffffff"];

function ConfettiBurst({ count = 72 }) {
  const pieces = Array.from({ length: count }).map((_, i) => {
    const left = Math.random() * 100;
    const delay = Math.random() * 0.4;
    const duration = 2 + Math.random() * 1.6;
    const color = COLORS[i % COLORS.length];
    const rotate = Math.random() * 360;
    const size = 6 + Math.random() * 10;
    return (
      <span
        key={i}
        className="confetti-piece"
        style={{
          left: `${left}%`,
          background: color,
          width: `${size}px`,
          height: `${size * 1.6}px`,
          transform: `rotate(${rotate}deg)`,
          animationDelay: `${delay}s`,
          animationDuration: `${duration}s`,
        }}
      />
    );
  });
  return <div className="absolute inset-0 pointer-events-none overflow-hidden">{pieces}</div>;
}

export default function VoteConfirmation({ option, votes, onDone, duration = 3000 }) {
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setClosing(true), duration - 350);
    const t2 = setTimeout(() => onDone?.(), duration);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [duration, onDone]);

  if (!option) return null;

  return (
    <div
      data-testid="vote-confirmation"
      className={`fixed inset-0 z-50 flex items-center justify-center px-6 ${closing ? "overlay-out" : "overlay-fade"}`}
      style={{
        background:
          "radial-gradient(120% 80% at 50% 0%, #348234 0%, #2a6328 45%, #1a3d1a 100%)",
      }}
    >
      <ConfettiBurst />

      <div className="relative text-center max-w-xl w-full pop-in">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/15 text-white/95 text-[10px] font-medium uppercase tracking-[0.3em] mb-7">
          <Sparkles className="w-3 h-3" /> Twój głos się liczy
        </div>

        <p className="font-display text-6xl sm:text-7xl text-white uppercase leading-[0.95] tracking-tight">
          Dzięki!
        </p>

        <div className="mt-7 inline-block max-w-full">
          <div
            data-testid="confirmed-city"
            className="font-display text-3xl sm:text-5xl text-white uppercase tracking-tight leading-tight border-y-2 border-white/40 py-3 px-6"
          >
            {option.city}
          </div>
          {option.skatepark && (
            <p className="mt-2.5 text-white/70 text-xs sm:text-sm font-medium uppercase tracking-[0.25em]">
              {option.skatepark}
            </p>
          )}
        </div>

        <div className="mt-9 flex flex-col items-center">
          <span
            data-testid="confirmed-vote-count"
            className="font-display text-6xl sm:text-7xl text-white tabular-nums leading-none"
          >
            {votes ?? 0}
          </span>
          <span className="mt-2 text-[10px] font-medium uppercase tracking-[0.35em] text-white/70">
            {votes === 1 ? "głos łącznie" : "głosów łącznie"}
          </span>
        </div>
      </div>
    </div>
  );
}
